import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

import EntityCard from "./EntityCard";

function EntityList({ entities, layer, language, onOpen }) {
  const { t } = useTranslation();

  if (!entities.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t("portfolioExplorer.empty")}
      </Typography>
    );
  }

  return entities.map((entity) => (
    <EntityCard
      key={entity.id}
      entity={entity}
      layer={layer}
      language={language}
      onOpen={onOpen}
    />
  ));
}

export default EntityList;
